import spinner from "../spinner";
import generateHtml from "./generate-html";

import iconWhiteAhead from "../../../Icons/NV/white/ahead.png";
import iconWhiteDone from "../../../Icons/NV/white/done.png";
import iconBlackBack from "../../../Icons/icons-black/back-arrow.png";
import iconBlackExit from "../../../Icons/icons-black/exit.png";
import GENRALHELPERS from "../GENRAL-HELPERS";
import firebase from "../firebase";
import signUpProfile from "../sign-up_profile/signUpProfile";
import settings from "../settings";
import allHandeling from "../handeling-all-displays/all-handeling";
import busineOwn from "../business-page-own-veiw/busine-own";




let businessDataResetTo = {
    name: 'Nombre de negocio',
    shortDescription: 'Descripción corta de tu negocio',
    views: '',
    images: { profile: { fullUrl: "" }, background: { fullUrl: "" } },
    shares: '',
    contacts: {
        call: {
            contact: "",
            contryCode: "52"
        },
        whatsApp: {
            contact: "",
            contryCode: "52"
        },
        email: {
            contact: ""
        },
        website: {
            contact: ""
        }
    },
    status: "active",
    about: "",
    place: {
        description: "",
        lat: "",
        lng: "",
        locationUrl: "",
        name: "",
        city: "",
        country: "",
        state: "",
    },
    businessTokens: [],
    moreData: {
        edit: false,
        imagesChaneged: false,
    },
    filterLat: '',
    filterLng: '',
    filterState: '',
    filterCountry: '',
    filterCity: '',
}

let businessData = {
    name: 'Nombre de negocio',
    shortDescription: 'Descripción corta de tu negocio',
    views: '',
    images: { profile: { fullUrl: "" }, background: { fullUrl: "" } },
    shares: '',
    contacts: {
        call: {
            contact: "",
            contryCode: "52"
        },
        whatsApp: {
            contact: "",
            contryCode: "52"
        },
        email: {
            contact: ""
        },
        website: {
            contact: ""
        }
    },
    status: "active",
    about: "",
    place: {
        description: "",
        lat: "",
        lng: "",
        locationUrl: "",
        name: "",
        city: "",
        country: "",
        state: "",
    },
    businessTokens: [],
    moreData: {
        edit: false,
        imagesChaneged: false,
    },
    filterLat: '',
    filterLng: '',
    filterState: '',
    filterCountry: '',
    filterCity: '',
}





// const arrStatus = {
//     Nombre: { status: "completed" },
//     Fotos: { status: "completed" },
//     Contacto: { status: "completed" },
//     Lugar: { status: "completed" },
//     Información: { status: "error" }
// };


let arrStatus = {
    Nombre: {
        name: { status: "", errorMessage: "" },
        description: { status: "", errorMessage: "" }
    },
    Fotos: {
        profile: { status: "", errorMessage: "" },
        background: { status: "", errorMessage: "" }
    },
    Contacto: {
        call: { status: "", errorMessage: "" },
        whatsApp: { status: "", errorMessage: "" },
        email: { status: "", errorMessage: "" }
    },
    Lugar: {
        link: { status: "", errorMessage: "" },
        description: { status: "", errorMessage: "" }
    },
    Información: {
        description: { status: "", errorMessage: "" },
        website: { status: "completed", errorMessage: "" }
    }
};



class NVBusinessEditor {
    _resetEditorStatus(arrStatus, resetTo = "") {
        const newStatus = {};

        for (const [step, subSteps] of Object.entries(arrStatus)) {
            newStatus[step] = {};

            for (const [key, subData] of Object.entries(subSteps)) {
                newStatus[step][key] = {
                    status: resetTo,
                    errorMessage: ""
                };
            }
        }

        return newStatus;
    }
    _updateEditorSteps(atNow, arrStatus) {
        const stepsContainer = document.getElementById("nvBusinessEditorCon8");
        const steps = Array.from(stepsContainer.querySelectorAll(".nvBusinessEditorCon9"));
        const errorMessageEl = document.getElementById("nvBusinessEditorErrorMessage");

        const stepNames = steps.map(step =>
            step.querySelector(".nvBusinessEditorText3, .nvBusinessEditorText3Act").textContent.trim()
        );

        const currentIndex = stepNames.indexOf(atNow);
        if (currentIndex === -1) return console.warn("⚠️ Step not found:", atNow);

        steps.forEach((step, i) => {
            const stepName = stepNames[i];
            const subSteps = arrStatus[stepName] || {};

            // Extract substep statuses (ignore errorMessage field)
            const statuses = Object.values(subSteps).map(sub => sub.status);

            const hasError = statuses.includes("error");
            const allCompleted = statuses.length > 0 && statuses.every(s => s === "completed");

            const textEl = step.querySelector(".nvBusinessEditorText3, .nvBusinessEditorText3Act");

            // Reset visuals
            step.classList.remove("nvBusinessEditorCon9Act");
            textEl.classList.remove("nvBusinessEditorText3Act");
            step.querySelector("[data-status='completed']").style.display = "none";
            step.querySelector("[data-status='error']").style.display = "none";

            // Mark active steps up to the current one
            if (i <= currentIndex) {
                step.classList.add("nvBusinessEditorCon9Act");
                textEl.classList.add("nvBusinessEditorText3Act");
            }

            // Set step-level indicators
            if (hasError) {
                step.querySelector("[data-status='error']").style.display = "flex";
            } else if (allCompleted) {
                step.querySelector("[data-status='completed']").style.display = "flex";
            }
        });

        // ✅ Handle error messages for the currently active step
        if (errorMessageEl) {
            const currentStepData = arrStatus[atNow];
            if (currentStepData) {
                // Collect all non-empty error messages from substeps
                const allErrors = Object.entries(currentStepData)
                    .map(([subKey, subData]) => subData?.errorMessage?.trim())
                    .filter(msg => msg && msg.length > 0);

                if (allErrors.length > 0) {
                    errorMessageEl.textContent = allErrors.join("\n");
                    errorMessageEl.classList.add("nvBusinessEditorText3BError");
                    errorMessageEl.classList.remove("nvBusinessEditorText3BGood");
                } else {
                    errorMessageEl.textContent = "Sin errores aquí";
                    errorMessageEl.classList.remove("nvBusinessEditorText3BError");
                    errorMessageEl.classList.add("nvBusinessEditorText3BGood");
                }
            } else {
                // Step not found (safety fallback)
                errorMessageEl.textContent = "Sin errores aquí";
                errorMessageEl.classList.remove("nvBusinessEditorText3BError");
                errorMessageEl.classList.add("nvBusinessEditorText3BGood");
            }
        }
    }



    _watchEditorScroll(containerId, arrStatus) {
        const container = document.getElementById(containerId);
        if (!container) return console.warn("⚠️ Container not found:", containerId);

        const sections = Array.from(container.querySelectorAll(".nvBusinessEditorCon10B"));
        if (sections.length === 0) return console.warn("⚠️ No editor sections found.");

        // IntersectionObserver to detect visible section
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                        const atNow = entry.target.dataset.step;
                        this._updateEditorSteps(atNow, arrStatus);
                        this._handleButtonUpdates({ to: atNow })
                    }
                });
            },
            {
                root: container, // Observe inside the scrollable container
                threshold: [0.6], // Step is considered "active" when 60% visible
            }
        );

        sections.forEach(sec => observer.observe(sec));
    }
    _scrollToEditorStep(directionOrStep) {
        const container = document.getElementById("nvBusinessEditorCon10");
        if (!container) {
            console.warn("⚠️ Editor container not found.");
            return null;
        }

        const steps = Array.from(container.querySelectorAll(".nvBusinessEditorCon10B"));
        const stepNames = steps.map(el => el.dataset.step);

        // 🧠 Detect which step is most visible in the scroll container
        let activeIndex = steps.findIndex(el => el.classList.contains("nvBusinessEditorCon10BAct"));
        let visibleIndex = activeIndex;

        const containerRect = container.getBoundingClientRect();
        let maxVisibleWidth = 0;

        steps.forEach((step, i) => {
            const rect = step.getBoundingClientRect();
            const visibleWidth = Math.min(rect.right, containerRect.right) - Math.max(rect.left, containerRect.left);
            if (visibleWidth > maxVisibleWidth) {
                maxVisibleWidth = visibleWidth;
                visibleIndex = i;
            }
        });

        // ✅ Use the most visible step as the current one
        activeIndex = visibleIndex !== -1 ? visibleIndex : 0;

        const prevStep = stepNames[activeIndex];
        let targetIndex = activeIndex;

        if (directionOrStep === "ahead") {
            targetIndex = Math.min(activeIndex + 1, steps.length - 1);
        } else if (directionOrStep === "back") {
            targetIndex = Math.max(activeIndex - 1, 0);
        } else {
            const stepNameIndex = stepNames.indexOf(directionOrStep);
            if (stepNameIndex !== -1) targetIndex = stepNameIndex;
            else {
                console.warn("⚠️ Step not found:", directionOrStep);
                return null;
            }
        }

        const targetStep = steps[targetIndex];
        if (!targetStep) return null;

        // Smooth scroll to it
        targetStep.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
        });

        // Update active class
        steps.forEach(s => {
            if (s) s.classList.remove("nvBusinessEditorCon10BAct")
        });
        targetStep.classList.add("nvBusinessEditorCon10BAct");

        const stepData = {
            from: prevStep,
            to: targetStep.dataset.step
        };

        // Hook for external updates
        this._handleButtonUpdates(stepData, directionOrStep);

        return stepData;
    }


    _initEditorStepClicks() {
        const stepsHeader = document.getElementById("nvBusinessEditorCon8");
        if (!stepsHeader) return console.warn("⚠️ Step header container not found.");

        const stepButtons = stepsHeader.querySelectorAll(".nvBusinessEditorCon9");

        stepButtons.forEach(btn => {
            btn.addEventListener("click", () => {
                const step = btn.dataset.step;
                if (!step) return;
                const returnStep = this._scrollToEditorStep(step);
            });
        });
    }


    _handleButtonUpdates(stepData, direction = null) {
        const nvBusinessEditorButtonStepBack = document.getElementById(
            "nvBusinessEditorButtonStepBack"
        );
        const nvBusinessEditorButtonStepAhead = document.getElementById(
            "nvBusinessEditorButtonStepAhead"
        );


        const buttonBackText = nvBusinessEditorButtonStepBack.querySelector('.nvBusinessEditorText4')
        const buttonBackIcon = nvBusinessEditorButtonStepBack.querySelector('img')
        const buttonAheadText = nvBusinessEditorButtonStepAhead.querySelector('.nvBusinessEditorText4B')
        const buttonAheadIcon = nvBusinessEditorButtonStepAhead.querySelector('img')




        if (stepData.from === "Nombre" && direction === "back") {
            const confirmExit = confirm(
                "¿Cerrar? Perderás todos los cambios que hiciste a tu página."
            );
            if (confirmExit) {
                this._closeBusinessEditor();
            }
        }
        if (stepData.from === "Información" && direction === "ahead") {
            const confirmSave = confirm(
                "¿Listo? Esto guardará todos tus cambios en tu página de negocio."
            );
            if (confirmSave) {
                this._NVBusinessCreateUpdate()

            }
        }

        if (stepData.to === "Nombre") {
            buttonBackText.textContent = "Cancelar"
            buttonBackIcon.src = iconBlackExit
            nvBusinessEditorButtonStepBack.classList.add("nvBusinessEditorCon12Exit")
        } else {
            buttonBackText.textContent = "Volver"
            buttonBackIcon.src = iconBlackBack
            nvBusinessEditorButtonStepBack.classList.remove("nvBusinessEditorCon12Exit")
        }
        if (stepData.to === "Información") {
            buttonAheadText.textContent = "Guardar"
            buttonAheadIcon.src = iconWhiteDone
            nvBusinessEditorButtonStepAhead.classList.add("nvBusinessEditorCon13Save")
        } else {
            buttonAheadText.textContent = "Siguiente"
            buttonAheadIcon.src = iconWhiteAhead
            nvBusinessEditorButtonStepAhead.classList.remove("nvBusinessEditorCon13Save")
        }
    }

    _activateDataGather() {
        const nvBusinessEditorShowName = document.getElementById('nvBusinessEditorShowName')
        const nvBusinessEditorShowShortDescription = document.getElementById('nvBusinessEditorShowShortDescription')

        const nvBusinessEditorInputBusinessName = document.getElementById('nvBusinessEditorInputBusinessName')
        const nvBusinessEditorInputBusinessShortDescription = document.getElementById('nvBusinessEditorInputBusinessShortDescription')
        const nvBusinessEditorInputWhatsAppNumberContryCode = document.getElementById('nvBusinessEditorInputWhatsAppNumberContryCode')
        const nvBusinessEditorInputWhatsAppNumber = document.getElementById('nvBusinessEditorInputWhatsAppNumber')
        const nvBusinessEditorInputCallNumberContryCode = document.getElementById('nvBusinessEditorInputCallNumberContryCode')
        const nvBusinessEditorInputCallNumber = document.getElementById('nvBusinessEditorInputCallNumber')
        const nvBusinessEditorInputEmail = document.getElementById('nvBusinessEditorInputEmail')

        const nvBusinessEditorButtonOpenLocationSelector = document.getElementById('nvBusinessEditorButtonOpenLocationSelector')

        const nvBusinessEditorInputLocationDescription = document.getElementById('nvBusinessEditorInputLocationDescription')
        const nvBusinessEditorInputBusinessDescription = document.getElementById('nvBusinessEditorInputBusinessDescription')
        const nvBusinessEditorInputWebsite = document.getElementById('nvBusinessEditorInputWebsite')



        // START Business name
        const setBusinessName = () => {
            let valueL = "Nombre de Negocio"
            let value = nvBusinessEditorInputBusinessName.value.trim()
            if (value.length > 0) {
                valueL = value
            }
            nvBusinessEditorShowName.textContent = valueL
            businessData.name = valueL

            if (value.length > 2) {
                arrStatus.Nombre.name.status = "completed"
                arrStatus.Nombre.name.errorMessage = ""
            } else {
                arrStatus.Nombre.name.status = "error"
                arrStatus.Nombre.name.errorMessage = "• El nombre debe ser por lo menos una palabra de 3 letras"
            }
            this._updateEditorSteps("Nombre", arrStatus)
        }
        nvBusinessEditorInputBusinessName.addEventListener('keyup', () => {
            setBusinessName()
        })
        nvBusinessEditorInputBusinessName.addEventListener('blur', () => {
            setBusinessName()
        })

        nvBusinessEditorButtonOpenLocationSelector.addEventListener('click', async () => {

            try {




                const locationData = await GENRALHELPERS._locationPicker(businessData.place)

                const locationTag = document.getElementById('nvBusinessEditorButtonOpenLocationSelectorLocationTag')
                locationTag.textContent = GENRALHELPERS._getDisplayLocationName(locationData)

                businessData.place.lat = locationData.lat;
                businessData.place.lng = locationData.lng;
                businessData.place.state = locationData.state;
                businessData.place.country = locationData.country;
                businessData.place.city = locationData.city;
                businessData.place.locationUrl = locationData.locationUrl;
                businessData.place.name = locationData.name;
                businessData.place.address = locationData.address;

                businessData.filterLat = locationData.lat;
                businessData.filterLng = locationData.lng;
                businessData.filterState = locationData.state;
                businessData.filterCountry = locationData.country;
                businessData.filterCity = locationData.city;

                console.log('LocationData', locationData, 'businessData', businessData);

                arrStatus.Lugar.link.status = "completed"
                arrStatus.Lugar.link.errorMessage = ""
                this._updateEditorSteps("Lugar", arrStatus)

            } catch (error) {
                console.log(error);


                if (error === 'cancelled') {
                    arrStatus.Lugar.link.status = "error"
                    arrStatus.Lugar.link.errorMessage = "• Nesecitas seleccionar una ubicación."
                    this._updateEditorSteps("Lugar", arrStatus)
                }
            }
        })


        // START Business Short Description
        const setBusinessShortDescription = () => {
            let valueL = "Descripción corta de tu negocio"
            let value = nvBusinessEditorInputBusinessShortDescription.value.trim()
            if (value.length > 0) {
                valueL = value
            }
            nvBusinessEditorShowShortDescription.textContent = valueL
            businessData.shortDescription = valueL

            if (value.split(" ").length > 3) {
                arrStatus.Nombre.description.status = "completed"
                arrStatus.Nombre.description.errorMessage = ""
            } else {
                arrStatus.Nombre.description.status = "error"
                arrStatus.Nombre.description.errorMessage = "• La descripción corta debe tener por lo menos 4 palabras"
            }
            this._updateEditorSteps("Nombre", arrStatus)
        }
        nvBusinessEditorInputBusinessShortDescription.addEventListener('keyup', () => {
            setBusinessShortDescription()
        })
        nvBusinessEditorInputBusinessShortDescription.addEventListener('blur', () => {
            setBusinessShortDescription()
        })


        // START WhatsApp
        const setWhatsAppNumber = () => {
            let valueL = ""
            let value = nvBusinessEditorInputWhatsAppNumber.value.trim()
            if (value.length > 0) {
                valueL = value
            }
            businessData.contacts.whatsApp.contact = valueL

            if (value.length === 10) {
                arrStatus.Contacto.whatsApp.status = "completed"
                arrStatus.Contacto.whatsApp.errorMessage = ""
            } else {
                arrStatus.Contacto.whatsApp.status = "error"
                arrStatus.Contacto.whatsApp.errorMessage = "• El número de WhatsApp debe tener exactamente 10 digitos"
            }
            this._updateEditorSteps("Contacto", arrStatus)
        }
        nvBusinessEditorInputWhatsAppNumber.addEventListener('keyup', () => {
            setWhatsAppNumber()
        })
        nvBusinessEditorInputWhatsAppNumber.addEventListener('blur', () => {
            setWhatsAppNumber()
        })
        nvBusinessEditorInputWhatsAppNumberContryCode.addEventListener("change", (e) => {
            const selectedValue = e.target.value;
            businessData.contacts.whatsApp.contryCode = selectedValue
        });


        // START Call
        const setCallNumber = () => {
            let valueL = ""
            let value = nvBusinessEditorInputCallNumber.value.trim()
            if (value.length > 0) {
                valueL = value
            }
            businessData.contacts.call.contact = valueL

            if (value.length === 10) {
                arrStatus.Contacto.call.status = "completed"
                arrStatus.Contacto.call.errorMessage = ""
            } else {
                arrStatus.Contacto.call.status = "error"
                arrStatus.Contacto.call.errorMessage = "• El número de llamadas debe tener exactamente 10 digitos"
            }
            this._updateEditorSteps("Contacto", arrStatus)
        }
        nvBusinessEditorInputCallNumber.addEventListener('keyup', () => {
            setCallNumber()
        })
        nvBusinessEditorInputCallNumber.addEventListener('blur', () => {
            setCallNumber()
        })
        nvBusinessEditorInputCallNumberContryCode.addEventListener("change", (e) => {
            const selectedValue = e.target.value;
            businessData.contacts.call.contryCode = selectedValue
        });


        // START email
        const setEmail = () => {
            let valueL = ""
            let value = nvBusinessEditorInputEmail.value.trim()
            if (value.length > 0) {
                valueL = value
            }
            businessData.contacts.email.contact = valueL

            const email = value;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (emailRegex.test(email)) {
                arrStatus.Contacto.email.status = "completed";
                arrStatus.Contacto.email.errorMessage = "";
            } else {
                arrStatus.Contacto.email.status = "error";
                arrStatus.Contacto.email.errorMessage = "• Este correo no es un correo válido";
            }
            this._updateEditorSteps("Contacto", arrStatus)
        }
        nvBusinessEditorInputEmail.addEventListener('keyup', () => {
            setEmail()
        })
        nvBusinessEditorInputEmail.addEventListener('blur', () => {
            setEmail()
        })


        // START location
        // const setLocationUrl = () => {
        //     let valueL = ""
        //     let value = nvBusinessEditorInputLocationLink.value.trim()
        //     if (value.length > 0) {
        //         valueL = value
        //     }

        //     function isValidMapLink(value) {
        //         try {
        //             const url = new URL(value);
        //             const { hostname } = url;

        //             // Normalize hostname (remove www.)
        //             const cleanHost = hostname.replace(/^www\./, "").toLowerCase();

        //             // List of known map domains
        //             const mapDomains = [
        //                 "google.com",
        //                 "maps.google.com",
        //                 "goo.gl",                // short Google Maps links
        //                 "apple.com",
        //                 "maps.apple.com",
        //                 "bing.com",
        //                 "maps.bing.com",
        //                 "waze.com",
        //                 "openstreetmap.org",
        //                 "mapy.cz",
        //                 "here.com"
        //             ];

        //             // Check if hostname includes any known map domain
        //             return mapDomains.some(domain => cleanHost.includes(domain));
        //         } catch {
        //             return false;
        //         }
        //     }

        //     if (isValidMapLink(value)) {
        //         arrStatus.Lugar.link.status = "completed"
        //         arrStatus.Lugar.link.errorMessage = ""
        //         businessData.place.locationUrl = valueL
        //     } else {
        //         arrStatus.Lugar.link.status = "error"
        //         arrStatus.Lugar.link.errorMessage = "• Este enlace de ubicación no es un enlace válido"
        //         businessData.place.locationUrl = "valueL"
        //     }
        //     this._updateEditorSteps("Lugar", arrStatus)
        // }


        const setLocationDiscription = () => {
            let valueL = ""
            let value = nvBusinessEditorInputLocationDescription.value.trim()
            if (value.length > 0) {
                valueL = value
            }
            businessData.place.description = valueL

            if (value.split(" ").length > 2) {
                arrStatus.Lugar.description.status = "completed"
                arrStatus.Lugar.description.errorMessage = ""
            } else {
                arrStatus.Lugar.description.status = "error"
                arrStatus.Lugar.description.errorMessage = "• Las descripción del lugar deber tener por lo menos 3 palabras"
            }
            this._updateEditorSteps("Lugar", arrStatus)
        }
        nvBusinessEditorInputLocationDescription.addEventListener('keyup', () => {
            setLocationDiscription()
        })
        nvBusinessEditorInputLocationDescription.addEventListener('blur', () => {
            setLocationDiscription()
        })


        // START location
        const setBusinessDescription = () => {
            let valueL = "Nombre de Negocio"
            let value = nvBusinessEditorInputBusinessDescription.value.trim()
            if (value.length > 0) {
                valueL = value
            }
            businessData.about = valueL

            if (value.split(" ").length > 9) {
                arrStatus.Información.description.status = "completed"
                arrStatus.Información.description.errorMessage = ""
            } else {
                arrStatus.Información.description.status = "error"
                arrStatus.Información.description.errorMessage = "• La descripción de tu negocio debe tener por lo menos 10 palabras"
            }
            this._updateEditorSteps("Información", arrStatus)
        }
        nvBusinessEditorInputBusinessDescription.addEventListener('keyup', () => {
            setBusinessDescription()
        })
        nvBusinessEditorInputBusinessDescription.addEventListener('blur', () => {
            setBusinessDescription()
        })

        // START website
        const setWebsite = () => {
            let valueL = ""
            let value = nvBusinessEditorInputWebsite.value.trim()
            if (value.length > 0) {
                valueL = value
            }

            function isValidHttpUrl(value) {
                try {
                    const url = new URL(value);
                    return url.protocol === "http:" || url.protocol === "https:";
                } catch (_) {
                    return false;
                }
            }

            if (value.length > 0) {
                if (isValidHttpUrl(value)) {
                    arrStatus.Información.website.status = "completed"
                    arrStatus.Información.website.errorMessage = ""
                    businessData.contacts.website.contact = valueL
                } else {

                    arrStatus.Información.website.status = "error"
                    arrStatus.Información.website.errorMessage = "• La dirección de tu página no es una dirección válida"
                    businessData.contacts.website.contact = ""
                }
            } else {
                arrStatus.Información.website.status = "completed"
                arrStatus.Información.website.errorMessage = ""
                businessData.contacts.website.contact = ""
            }

            this._updateEditorSteps("Información", arrStatus)
        }
        nvBusinessEditorInputWebsite.addEventListener('keyup', () => {
            setWebsite()
        })
        nvBusinessEditorInputWebsite.addEventListener('blur', () => {
            setWebsite()
        })


    }
    _events() {
        const nvBusinessEditorButtonStepBack = document.getElementById(
            "nvBusinessEditorButtonStepBack"
        );
        const nvBusinessEditorButtonStepAhead = document.getElementById(
            "nvBusinessEditorButtonStepAhead"
        );
        const nvBusinessEditorButtonClose = document.getElementById(
            "nvBusinessEditorButtonClose"
        );

        nvBusinessEditorButtonStepBack.addEventListener("click", () => {
            const returnStep = this._scrollToEditorStep('back')
        });
        nvBusinessEditorButtonStepAhead.addEventListener("click", () => {
            const returnStep = this._scrollToEditorStep('ahead')
        });

        nvBusinessEditorButtonClose.addEventListener("click", () => {
            const confirmExit = confirm(
                "¿Cerrar? Perderás todos los cambios que hiciste a tu página."
            );
            if (confirmExit) {
                this._closeBusinessEditor();
            }
        });

        this._watchEditorScroll("nvBusinessEditorCon10", arrStatus)
        this._initEditorStepClicks()
    }

    _closeBusinessEditor() {
        const MainContainerBusinessPageBuild = document.getElementById(
            "MainContainerBusinessPageBuild"
        );
        MainContainerBusinessPageBuild.remove();
    }
    _bindImageInputToDisplay(inputId, displayImgId) {
        const input = document.getElementById(inputId);
        const display = document.getElementById(displayImgId);

        if (!input || !display) {
            console.error("bindImageInputToDisplay: invalid IDs provided.");
            return;
        }

        input.addEventListener("change", (event) => {
            const file = event.target.files && event.target.files[0];
            if (!file) return;

            if (!file.type.startsWith("image/")) {
                console.error("Selected file is not an image.");
                display.src = ""; // clear
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                display.src = e.target.result;

                console.log(displayImgId);
                if (displayImgId === 'nvBusinessEditorImgProfile') {
                    arrStatus.Fotos.profile.status = "completed"
                    businessData.moreData.imagesChaneged = true
                }
                if (displayImgId === 'nvBusinessEditorImgBackground') {
                    arrStatus.Fotos.background.status = "completed"
                    businessData.moreData.imagesChaneged = true
                }
                this._updateEditorSteps("Fotos", arrStatus)

            };
            reader.readAsDataURL(file);
        });
    }



    _init(data, edit = false) {


        const userData = firebase._getLatestCurrentUserData();
        console.log(userData);
        const hasOwnerBusiness = userData.businesses?.some(
            business => business?.role === 'owner'
        ) ?? false;


        // Need to be turned on in production
        if (!edit && hasOwnerBusiness) {
            busineOwn._init()

            return
        }
        if (!userData.whatsAppNumber) {
            signUpProfile._open(true)
            return
        }

        if (!edit) {
            businessData = { ...businessDataResetTo }
        }

        (businessData ??= {}).moreData ??= {};
        businessData.moreData.imagesChaneged = false
        businessData.moreData.edit = false
        console.log(edit);
        if (edit) {
            businessData = data;
            (businessData ??= {}).moreData ??= {};
            businessData.moreData.edit = true
            businessData.moreData.businessId = businessData.businessId
            arrStatus = this._resetEditorStatus(arrStatus, "completed")
        }

        const container = document.getElementById("MainAppContentContainer");
        const busineesPageEditorHtml = generateHtml._NVBusinessEditor(businessData, edit);
        container.insertAdjacentHTML("beforeend", busineesPageEditorHtml);

        this._events(edit);
        this._activateDataGather()
        this._bindImageInputToDisplay('nvBusinessEditorImgBackgroundInput', 'nvBusinessEditorImgBackground')
        this._bindImageInputToDisplay('nvBusinessEditorImgProfileInput', 'nvBusinessEditorImgProfile')
        spinner._hideSpinner()

        GENRALHELPERS._guardNumericInput("nvBusinessEditorInputWhatsAppNumber")
        GENRALHELPERS._guardNumericInput("nvBusinessEditorInputCallNumber")
    }


    _getImages(from) {
        if (from === 'back') {
            return businessData.images.background[0]
        }
        if (from === 'prof') {
            return businessData.images.profile[0]
        }
    }

    async _NVBusinessCreateUpdate() {

        try {
            spinner._displaySpinner("Guardando información de negocio", 30000);

            if (businessData.moreData.imagesChaneged) {
                const backgroundImg = await firebase._uploadImagesAndGetReferences(
                    "nvBusinessEditorImgBackground", 'imageProgressCon', true, 'public/tempUploads/', 'businessBackground'
                )
                const profileImg = await firebase._uploadImagesAndGetReferences(
                    "nvBusinessEditorImgProfile", 'imageProgressCon', true, 'public/tempUploads/', 'businessProfile'
                )
                businessData.images.background = backgroundImg
                businessData.images.profile = profileImg
                businessData.moreData.adminImgPath = 'public/businesses'
                console.log('backgroundImg', backgroundImg);
                console.log('profileImg', profileImg);
            }


            if (!businessData.moreData.edit) {
                businessData.moreData.businessStatus = settings._getAppUploadStatus()
            }

            console.log(businessData);

            // return
            const createResult = await firebase._NVcreateUpdateBusiness(
                businessData
            );
            console.log(createResult);
            if (createResult.data.status === "error") {
                throw new Error(createResult.data.message);
            }
            if (createResult.data.status === "success") {
                alert(`Exito: ${createResult.data.message}`);
                this._closeBusinessEditor();
                busineOwn._NVDipslayBusinesses()
                // Logic to open business after create/edit goes here

                // Ensure correct data is passed
                allHandeling._displayTheRightWay(
                    createResult.data.id,
                    '',
                    'business',
                    '',
                    null,
                    '',
                    true,
                    null,
                    true
                );

            }
        } catch (error) {

            console.error(error.message);
            alert(`Error: ${error.message}`);
        } finally {
            spinner._hideSpinner()
        }
    }

}

export default new NVBusinessEditor()


